import { useGetAllocatedStat } from 'common/queries-and-mutations/general';
import { Loader } from 'components/Loader';
import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

export default function AllocationStat() {
  const { data: stats, isLoading } = useGetAllocatedStat();

  const allValuesEmpty = (stats ?? []).every(item => item.value === null);

  const computeResult = useMemo(() => {
    const label = [];
    const value = [];

    if (stats && !allValuesEmpty) {
      for (let i = 0; i < stats.length; i++) {
        const stat = stats[i];

        label.push(stat.label);
        value.push(Number(stat.value) / stat.totalAccount);
      }
      return { label, value };
    }
  }, [stats]);

  return (
    <div>
      {isLoading && !computeResult ? (
        <div className="mt-10 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          {allValuesEmpty ? (
            <>
              <div className="flex flex-col items-center justify-center">
                <div className="flex items-center">
                  <div className="z-10s flex h-[13rem] w-[13rem] shrink-0 items-center justify-center rounded-full bg-[#FF6600]">
                    <div className="flex h-40 w-40 items-center justify-center rounded-full bg-white">
                      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-center shadow-2xl">
                        <p className="text-2xl text-[#353535]">N/A</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex h-0.5 w-full bg-gray-200 dark:bg-gray-700"></div>
                </div>
              </div>
            </>
          ) : (
            <Chart
              type="donut"
              width={439}
              height={245}
              series={computeResult?.value}
              options={{
                responsive: [
                  {
                    breakpoint: undefined,
                    options: {}
                  }
                ],
                labels: computeResult?.label,
                colors: [
                  '#007AFF',
                  '#97E3D5',
                  '#FB8832',
                  '#9B51E0',
                  '#0D2864',
                  '#F47560'
                ],
                plotOptions: {
                  pie: {
                    expandOnClick: true,
                    startAngle: 0,
                    offsetX: 0,
                    offsetY: 0,
                    customScale: 1,
                    dataLabels: {
                      offset: 0,
                      minAngleToShowLabel: 10
                    },
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          show: false
                        },
                        total: {
                          show: true,
                          showAlways: true,
                          // fontSize: 30,
                          color: '#373d3f',
                          fontWeight: 700,
                          formatter: function (w: {
                            globals: { seriesTotals: any[] };
                          }) {
                            const total = w.globals.seriesTotals.reduce(
                              (a: any, b: any) => {
                                return a + b;
                              },
                              0
                            );
                            return (
                              (total / w.globals.seriesTotals.length).toFixed(
                                2
                              ) + '%'
                            );
                          }
                        }
                      }
                    }
                  }
                },
                legend: {
                  position: 'bottom',
                  horizontalAlign: 'center'
                },
                dataLabels: {
                  formatter: function (val: number) {
                    return val / 4 + '%';
                  },
                  enabled: false
                }
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
